import { Box, Field, Select } from '@workwhile/ui'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FiltersSchema } from '../../filtersSchema'

const options = [
  { label: 'Standby', value: true },
  { label: 'Non-standby', value: false },
]

type IsStandbyOption = (typeof options)[number]

export const IsStandbyFilter = () => {
  const { setValue, watch } = useFormContext<FiltersSchema>()
  const isStandby = watch('shift.isStandby')

  return (
    <Box width="256px">
      <Field>
        <Select
          block
          isClearable
          options={options}
          value={options.find((o) => o.value === isStandby) ?? null}
          onChange={(option: IsStandbyOption | null) => {
            setValue('shift.isStandby', option?.value ?? null)
          }}
        />
      </Field>
    </Box>
  )
}
